import { Command } from 'cmdk';
import { IconSearch, IconX } from '@tabler/icons-react';

export function SearchInput({
  searchRef,
  value,
  onChange,
}: {
  searchRef: React.RefObject<HTMLInputElement | null>;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="flex h-12 items-center gap-4 px-4">
      <IconSearch size={16} />
      <Command.Input
        ref={searchRef}
        value={value}
        onValueChange={onChange}
        placeholder="Type a command or search..."
        className="w-full border-[#dee2e6] bg-transparent outline-none dark:border-[#424242]"
      />
      {value ?
        <div
          onClick={() => {
            onChange('');
            searchRef.current?.focus();
          }}
          className="cursor-pointer rounded-full bg-gray-100 p-1 text-gray-500 dark:bg-[#424242] dark:text-gray-400"
        >
          <IconX size={12} />
        </div>
      : null}
    </div>
  );
}
